import SkyNetTable from 'app/shared-components/SkyNetTable'
import SkyNetDomain, {
    SidebarTab,
} from 'app/shared-components/SkyNetDomain'
import {
    TableControlTypes,
} from 'app/shared-components/TableControls/TableControls.types'
import useHasPermission from 'app/hooks/useHasPermission'

import useTabsByPermission from 'app/hooks/useTabsByPermission'
import {
    CommonRoutes,
} from 'app/enums/common.enums'
import {
    CompaniesTabs,
} from 'app/enums/domain.enums'
import CompanyOverview from './CompanyOverview'
import CompanyCreate from './CompanyCreate'
import CompanyUpdate from './CompanyUpdate'
import tableConfig from './Companies.config'
import SkyMindSync from './SkyMindSync'
import Tracking from './Tracking'

const tableControls: TableControlTypes[] = [
    TableControlTypes.ShowArhived,
    TableControlTypes.ClearFilters,
    TableControlTypes.ClearSorting,
]

const Companies = () => {
    const isAllowedToCreateCompany = useHasPermission(['company_create'])
    const isAllowedToUpdateCompany = useHasPermission(['company_update'])
    const isAllowedToUpdateSkyMindCompany = useHasPermission(['company_skymind_update'])
    const isCompanyUpdateOps = useHasPermission(['company_update_ops'])

    const tabs: SidebarTab[] = useTabsByPermission([
        {
            permission: true,
            tab: {
                url: CommonRoutes.Overview,
                label: 'Overview',
                Component: CompanyOverview,
            },
        },
        {
            permission: isAllowedToUpdateCompany,
            tab: {
                url: CommonRoutes.DataUpdate,
                label: 'Data Update',
                Component: CompanyUpdate,
            },
        },
        {
            permission: isAllowedToUpdateSkyMindCompany,
            tab: {
                url: CompaniesTabs.SkyMind,
                label: 'SkyMind',
                Component: SkyMindSync,
            },
        },
        {
            permission: isCompanyUpdateOps,
            tab: {
                url: CompaniesTabs.Tracking,
                label: 'Tracking',
                Component: Tracking,
            },
        },
    ])

    return (
        <SkyNetDomain
            actionComponents={{
                Create: isAllowedToCreateCompany ? CompanyCreate : undefined,
            }}
            name="Company"
            sidebarTabs={tabs}
        >
            <SkyNetTable
                tableControls={tableControls}
                tableConfig={tableConfig}
                showSearch
            />
        </SkyNetDomain>
    )
}

export default Companies
